import Vue from 'vue'
import VueRouter from 'vue-router'
import loginRoutes from './login'
import postRoutes from './posts'
import NotificationNavRoutes from './notifications'
import ProfileNavRoutes from './profile'
import PageNotFound from '@/views/404'
import store from '@/store'
import { RegisterEvent } from '@/analytics'

Vue.use(VueRouter)

function setValidationRoute (routerNav) {
  routerNav.afterEach((to, from) => {
    if (to.meta && to.meta.topScroll) window.scrollTo(0, to.meta.topScroll)
    setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (to.meta && to.meta.topScroll) {
            window.scrollTo(0, to.meta.topScroll)
          }
        })
      })
    }, 100)
  })

  routerNav.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const requiresGuess = to.matched.some(x => x.meta.requiresGuess)
    const isAuthenticated = store.getters.isAuthenticated()

    if (routerNav.history.stack.length !== 0) {
      routerNav.history.stack[routerNav.history.index].meta.topScroll =
        window.scrollY
    }
    if (requiresAuth && !isAuthenticated) {
      next({ name: 'Login' })
    } else if (requiresGuess && isAuthenticated) {
      next({ name: 'Homepage' })
    } else {
      if (requiresAuth && isAuthenticated) {
        // if (store.getters.firebaseUUID() && (to.name === 'Homepage')) {
        //   store.dispatch('CALC_BADGE')
        // }
        if (from.name === 'Login') {
          store.dispatch('GET_PROFILE_BY_USER', store.getters.firebaseUUID())
          const isMuted = store.getters.getMuted
            ? 'chi_video_mute'
            : 'chi_video_unmute'
          RegisterEvent('chi_user_login', {
            target_id: store.getters.firebaseUUID(),
            target_type: 'user_id'
          })
          RegisterEvent(isMuted, {
            target_id: 'chi_login',
            target_type: 'global_event'
          })
        }
      }

      window.history.replaceState({}, document.title, to.path)
      next()
    }
  })
}

const routes = [
  ...loginRoutes,
  ...postRoutes,
  { path: '*', component: PageNotFound }
]

export const router = new VueRouter({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes
})

export const NotificationNavRouter = new VueRouter({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes: [...NotificationNavRoutes, { path: '*', component: PageNotFound }]
})

export const ProfileNavRouter = new VueRouter({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes: [...ProfileNavRoutes, { path: '*', component: PageNotFound }]
})

setValidationRoute(router)
setValidationRoute(NotificationNavRouter)
setValidationRoute(ProfileNavRouter)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js